import React from "react";
import Layout from "src/components/layout/website/Layout";

const FAQsPage: React.FC = () => {
  const faqs = [
    {
      q: "What is Invyntra?",
      a: "Invyntra is a cloud-based inventory management platform designed for small and medium businesses.",
    },
    {
      q: "Is there a free trial?",
      a: "Yes! You can try Invyntra free for 14 days with full access to all features.",
    },
    {
      q: "Can I manage multiple branches?",
      a: "Absolutely. Invyntra supports multi-tenant architecture for multiple branches or clients.",
    },
    {
      q: "Can I export reports?",
      a: "Yes, you can export detailed reports in Excel or PDF format anytime.",
    },
  ];

  return (
    <Layout>
      <div className="min-h-screen bg-white py-20 px-6 max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-indigo-600 text-center mb-12">
          Frequently Asked Questions
        </h1>
        <div className="space-y-8">
          {faqs.map((item, i) => (
            <div key={i} className="border-b pb-4">
              <h3 className="font-semibold text-lg text-gray-800 mb-2">
                {item.q}
              </h3>
              <p className="text-gray-600">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default FAQsPage;
